import {
  ACCESS_CSV, ACCESS_CSV_FAILURE, ACCESS_CSV_SUCCESS
} from './mutation-types'

export default {
  state: {
    users: []
  },
  getters: {
    csvUsers: state => {
      return state.users
    }
  },
  actions: {
    [ACCESS_CSV] ({dispatch, state, commit}, params = null) {
      console.log('ACCESS_CSV')
      var callback = () => {}
      var data = {}
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', { url: '/master/access', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(ACCESS_CSV_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(ACCESS_CSV_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [ACCESS_CSV_FAILURE] (state, data) {
      console.log('ACCESS_CSV_FAILURE')
    },
    [ACCESS_CSV_SUCCESS] (state, data) {
      console.log('ACCESS_CSV_SUCCESS')
      state.users = data.data.data
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/access.js